export default "__VITE_ASSET__BnyNtjUm__"